/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';
import ChevronRight from '../../assets/chevron-right.svg';
import { useIntl } from 'react-intl';
import historyMenuListStyles from './history-menu-list.styles';
import { useTransactionHistory } from '../../hooks/useTransactionHistory';
import { NavLink } from 'react-router-dom';
import { formatDateToLocaleString } from '../../utils/utils';

type Props = {
    onClick?: () => void;
    onMenuClose: () => void;
    isMenuOpen: boolean;
};

const HistoryMenuList = (props: Props) => {
    const { onClick, onMenuClose } = props;
    const intl = useIntl();
    const [isExpanded, setIsExpanded] = useState(false);

    const { transactionsHistory } = useTransactionHistory();

    if (transactionsHistory.length === 0) {
        return null;
    }

    const clickHandler = () => {
        if (onClick) {
            onClick();
        }
        setIsExpanded(state => !state);
    };

    const listItemClickHandler = () => {
        setIsExpanded(false);
        onMenuClose();
    };

    return (
        <div css={historyMenuListStyles.container}>
            <span css={historyMenuListStyles.listElement} onClick={clickHandler}>
                {intl.formatMessage({ id: 'menu.history' })}
                <img
                    src={ChevronRight}
                    alt={'Chevron right'}
                    css={historyMenuListStyles.chevronRight}
                    style={{ transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)' }}
                />
            </span>
            {isExpanded && (
                <div css={historyMenuListStyles.list}>
                    {transactionsHistory.map(transaction => {
                        const startDate = new Date(transaction.transaction.startAt);
                        const totalMinutes = transaction.transaction.duration;
                        const hours = Math.floor(totalMinutes / 60);
                        const minutes = totalMinutes % 60;
                        const durationString =
                            hours > 0
                                ? `${hours}${intl.formatMessage({ id: 'unit.h' })} ${minutes}${intl.formatMessage({ id: 'unit.m' })}`
                                : `${minutes}${intl.formatMessage({ id: 'unit.m' })}`;
                        return (
                            <>
                                {/* <div css={historyMenuListStyles.listItem} key={transaction._id}>{transaction.transaction.__id}</div> */}
                                <NavLink
                                    css={[
                                        historyMenuListStyles.listElement,
                                        historyMenuListStyles.historyItemLink,
                                    ]}
                                    onClick={listItemClickHandler}
                                    to={`/charge/${transaction._id}`}>
                                    <div css={historyMenuListStyles.historyItemContent}>
                                        <div css={historyMenuListStyles.historyItemTopLine}>
                                            <span css={historyMenuListStyles.historyItemDate}>
                                                {formatDateToLocaleString(startDate)}
                                            </span>
                                            <span
                                                css={
                                                    historyMenuListStyles.historyItemPrice
                                                }>{`-${Number(transaction?.paymentIntent?.amount / 100).toFixed(2)} ${transaction.pricing.currency}`}</span>
                                        </div>
                                        <span
                                            css={
                                                historyMenuListStyles.historyItemData
                                            }>{`${Number((transaction?.energy ?? 0) / 1000).toFixed(3)} ${intl.formatMessage({ id: 'unit.kWh' })} | ${durationString}`}</span>
                                    </div>
                                    <img
                                        src={ChevronRight}
                                        alt={'Chevron right'}
                                        css={[historyMenuListStyles.chevronRightSmall]}
                                    />
                                </NavLink>
                            </>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default HistoryMenuList;
